
  const form   = document.getElementById('lookup_form');

  const msg    = document.getElementById('form_msg');

  const result = document.getElementById('lookup_result');
 
  // NEW: fields

  const psinInp   = form.querySelector('#psin_field');

  const webInp    = form.querySelector('#web_field');

  const refHidden = form.querySelector('#order_ref_hidden');

  const surnameInp = form.querySelector('input[name="surname"]'); // NEW
 
  // Helpers (unchanged)

  const escapeHTML = (s='') => String(s)

    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')

    .replace(/"/g,'&quot;').replace(/'/g,'&#039;');

  const fmtDateAU = iso => {

    if (!iso) return '-';

    const d = new Date(iso + 'T00:00:00');

    if (isNaN(d)) return '-';

    const dd = String(d.getDate()).padStart(2,'0');

    const mm = String(d.getMonth()+1).padStart(2,'0');

    const yy = d.getFullYear();

    return `${dd}/${mm}/${yy}`;

  };

  const fmtMoney = n => (n === null || n === undefined || isNaN(n)) ? '' : `$${Number(n).toFixed(2)}`;
 
  // --- normalize and sync hidden order_ref (existing) ---

  function onlyDigits(s) { return (s || '').replace(/\D+/g,''); }

  function syncHidden() {

    const psin = onlyDigits(psinInp.value);

    const web  = onlyDigits(webInp.value);
 
    if (document.activeElement === psinInp && psin) {

      webInp.value = ''; // mutually exclusive

    } else if (document.activeElement === webInp && web) {

      psinInp.value = '';

    }
 
    const psinNow = onlyDigits(psinInp.value);

    const webNow  = onlyDigits(webInp.value);
 
    if (psinNow)      refHidden.value = `PSIN-${psinNow}`;

    else if (webNow)  refHidden.value = `WEB-#${webNow}`;

    else              refHidden.value = '';

  }

  psinInp.addEventListener('input', syncHidden);

  webInp.addEventListener('input', syncHidden);
 
  function clearFieldWarnings() {

    document.querySelector('.surn')?.classList.remove('warning');

    document.querySelector('.psin')?.classList.remove('warning');

    document.querySelector('.web')?.classList.remove('warning');

  }
 
  // === NEW: URL autofill + auto-submit ======================================

  function getParamsInsensitive() {

    const out = {};

    // 1) Normal query string

    const usp = new URLSearchParams(window.location.search);

    usp.forEach((v,k) => { out[k.toLowerCase()] = v; });
 
    // 2) Fallback: scan entire href so we can catch odd separators like ?key=...?... or &key=...

    const href = String(window.location.href);

    const re = /[?&]([^=?&#]+)=([^&#]*)/g;

    let m;

    while ((m = re.exec(href))) {

      const k = decodeURIComponent(m[1] || '').toLowerCase();

      const v = decodeURIComponent(m[2] || '');

      if (!(k in out)) out[k] = v; // don't override if already present

    }

    return out;

  }
 
  function prefillFromURL() {

    const p = getParamsInsensitive();
 
    // Param aliases

    let orderId = p.orderid || p.order_id || p.ordernumber || p.order || p.ref || '';

    let last = p.surname || p.lastname || p.last_name || p.lname || '';
 
    // Recover WEB value if someone passed "WEB-#1234" (fragment holds the number)

    if (orderId && /^web-?$/i.test(orderId.trim()) && window.location.hash) {

      const hashDigits = onlyDigits(window.location.hash);

      if (hashDigits) orderId = `WEB-${hashDigits}`;

    }
 
    // Fill surname

    if (last && surnameInp) {

      surnameInp.value = last;

    }
 
    // Fill PSIN / WEB (mutually exclusive)

    if (orderId) {

      const v = orderId.trim();

      if (/^psin\b/i.test(v)) {

        psinInp.value = onlyDigits(v);

        webInp.value = '';

      } else if (/^web\b/i.test(v) || /\bweb\b/i.test(v)) {

        webInp.value = onlyDigits(v) || onlyDigits(window.location.hash);

        psinInp.value = '';

      } else if (/#/.test(v)) { // looks like WEB-#1234 but missing WEB

        webInp.value = onlyDigits(v) || onlyDigits(window.location.hash);

        psinInp.value = '';

      } else {

        // default: assume PSIN if no recognizable prefix

        psinInp.value = onlyDigits(v);

        webInp.value = '';

      }

    }
 
    // Sync hidden field now that we set visible fields

    syncHidden();
 
    // Auto-submit if both surname and one ref are present

    const hasSurname = !!(surnameInp && surnameInp.value.trim());

    const hasRef = !!refHidden.value;

    if (hasSurname && hasRef) {

      // allow layout to paint before submitting

      setTimeout(() => {

        // Use requestSubmit so native validation still runs

        if (typeof form.requestSubmit === 'function') form.requestSubmit();

        else form.submit();

      }, 50);

    }

  }

  // Run immediately (script is after the form)

  prefillFromURL();

  // ===========================================================================


// ===================== NEW: Adjust Paid/Pending using t_match.link_this_amt =====================

function getAdjustedPayment(data) {

  const total = Number(data?.proforma_inc_gst || 0);
 
  // API raw values

  const pendingRaw = Number(data?.pending || 0);
 
  // Your existing "paid" logic was using account_outstanding (abs)

  const basePaid = (data?.account_outstanding !== null && data?.account_outstanding !== undefined)

    ? Math.abs(Number(data.account_outstanding || 0))

    : Math.max(0, total - pendingRaw);
 
  // Sum link_this_amt from t_match[]

  const t = Array.isArray(data?.t_match) ? data.t_match : [];

  const linked = t.reduce((sum, row) => sum + (Number(row?.link_this_amt) || 0), 0);
 
  // Adjust amounts (don’t go below 0)

  const pending = Math.max(0, pendingRaw - linked);

  const paid    = Math.max(0, basePaid + linked);
 
  return { total, paid, pending, linked, pendingRaw, basePaid };

}

 



function insertEwayButtonIfNeeded(data) {
  const payCalc = getAdjustedPayment(data);
  //const pending = Number(data?.pending || 0);
   const pending = Number(payCalc.pending || 0);
  const holder  = document.getElementById('ewayPayNow');
  const noteEl  = document.getElementById('ewayNote');
  if (!holder) return;

  holder.innerHTML = '';
  document.getElementById('ecrypt-loader-dynamic')?.remove();

  if (!pending || isNaN(pending) || pending <= 0) {
    noteEl && (noteEl.textContent = 'No payment due.');
    return;
  }

  const amountCents = Math.round(pending * 100);
  const email = (data.customer.email || '').trim();
   const phone = (data.customer.phone || '' ).trim();
  const ref   = (document.getElementById('order_ref_hidden')?.value || '').trim();

  if (!ref) {
    noteEl && (noteEl.textContent = 'Reference not found — cannot initiate payment.');
    return;
  }

  // 1) Build the REQUIRED script tag that eWAY scans
  const payScript = document.createElement('script');
  payScript.className = 'eway-paynow-button';
  payScript.setAttribute('data-publicapikey', 'epk-1A6382B5-BAC5-44F1-B6F5-F06CDA4B9B53'); // <- replace
  //payScript.setAttribute('data-amount', String(amountCents)); // integer cents
   payScript.setAttribute('data-amount', '100'); // integer cents
  payScript.setAttribute('data-currency', 'AUD');
  payScript.setAttribute('data-description', `Order ${ref}`);
  //payScript.setAttribute('data-resulturl', `https://tfg.tellmedia.com.au/resultspayapi.php?ref=${encodeURIComponent(ref)}`);
  if (email){ payScript.setAttribute('data-email', email);}
  if (phone) {payScript.setAttribute('data-phone', phone);}
  

  // Important: src must be the eCrypt URL on THIS element
  payScript.src = 'https://secure.ewaypayments.com/scripts/eCrypt.min.js';

  holder.appendChild(payScript);

  // 2) Some themes include eCrypt globally already; if not, force a reload after append
  //    (This extra loader is harmless; eWAY ignores duplicates)
  const loader = document.createElement('script');
  loader.id = 'ecrypt-loader-dynamic';
  loader.src = 'https://secure.ewaypayments.com/scripts/eCrypt.min.js';
  loader.onload = () => {
    // eWAY scans the DOM now and wires the button; click should open the iframe
    // console.log('eWAY initialized.');
  };
  document.body.appendChild(loader);

  noteEl && (noteEl.textContent = 'Click “Pay Now” to complete the pending balance securely.');
}


                        
  function renderSummary(data) {

    const typeLabel = data.type === 'online' ? 'Online Ref' : 'PSIN';

    const orderNo   = data.order?.orderNo || '';

    const orderDate = fmtDateAU(data.order?.orderDate);

    const cust = data.customer || {};

    const del  = data.delivery || {};

    const joinAddr = (o) => {

      const parts = [

        o.name, o.line1, o.line2,

        [o.city, o.state, o.post].filter(Boolean).join(' '),

        o.phone ? `Mb: ${o.phone}` : '',

        o.email ? `Email: <a href="mailto:${escapeHTML(o.email)}">${escapeHTML(o.email)}</a>` : ''

      ].filter(Boolean);

      return parts.length ? parts.join('<br>') : '—';

    };

    const rows = (data.items || []).map(it => {
const qty = it.qty ?? it.quantity ?? it.qty_ordered ?? it.order_qty ?? it.Qty ?? 1;
      return `<tr>
<td>${escapeHTML(it.sku)}</td>
<td style="font-weight:600;">${escapeHTML(it.name || '-')}</td>
<td style="color:#D5A07F;">${fmtMoney(it.price)}</td>
<td class="qty">${escapeHTML(String(qty))}</td>
<td>${escapeHTML(fmtDateAU(it.eta_date))}</td>
</tr>`;

    }).join('') || `<tr><td colspan="4">No items found.</td></tr>`;

    const notes = window.ETA_NOTES || data.notes || {};
 
const bullets = (notes.bullets || [])
  .map(li => `<li>${escapeHTML((li || '').trim())}</li>`)
  .join('');
 

   // const bullets = (data.notes?.bullets || []).map(li => `<li>${escapeHTML(li)}</li>`).join('');

    // >>> NEW: payment card (expects your PHP to return data.payment {...})

  const pay = data.pending || {};

// const payHTML = (pay && (data.proforma_inc_gst !== undefined || data.pending !== undefined)&&(data.proforma_inc_gst != data.pending ))? `
// <div class="bx">
// <div class="t1">Payment</div>
// <div class="t2">
// <div>Total: <strong>${fmtMoney(data.proforma_inc_gst)}</strong></div>
// <div>Paid: <strong>${fmtMoney(Math.abs(data.account_outstanding))}</strong></div>
// <div>Pending balance: <strong>${fmtMoney(data.pending)}</strong></div>
// </div>
// <!-- eWAY button placeholder -->
//   <div id="ewayPayNow"></div>
//   <div id="ewayNote" style="font-size:14px;margin-top:8px;"></div>
// </div>`: '';


const payCalc = getAdjustedPayment(data);
 
const payHTML =

  (data.proforma_inc_gst !== undefined || data.pending !== undefined) &&

  (Number(data.proforma_inc_gst) != Number(data.pending))

  ? `
<div class="bx">
<div class="t1">Payment</div>
<div class="t2">
<div>Total: <strong>${fmtMoney(payCalc.total)}</strong></div>
<div>Paid: <strong>${fmtMoney(payCalc.paid)}</strong></div>
<div>Pending balance: <strong>${fmtMoney(payCalc.pending)}</strong></div>

    ${payCalc.linked ? `<div style="display:none;">Matched amount: ${fmtMoney(payCalc.linked)}</div>` : ``}
</div>
 
  <div id="ewayPayNows"></div>
<div id="ewayNotes" style="font-size:14px;margin-top:8px;"></div>
</div>`: '';


    return `
<section class="lookup_summary">
<div class="tp">
<div class="lt">${typeLabel} - ${escapeHTML(orderNo)}</div>
<div class="rt">Order Date - ${escapeHTML(orderDate)}</div>
</div>
<div class="md">
<div class="bx">
<div class="t1">Customer ${escapeHTML(cust.name || '')}</div>
<div class="t2">${joinAddr(cust)}</div>
</div>
<div class="bx">
<div class="t1">Delivery address</div>
<div class="t2">${joinAddr(del)}</div>
</div>
 ${payHTML} <!-- NEW: payment card appears here -->
</div>
<div class="TableWrapper">
<table class="tbl">
<thead>
<td>SKU</td>
<td>Product Name</td>
<td>Price</td>
<td>Quantity</td>
<td>ETA Date</td>
</thead>
<tbody>${rows}</tbody>
</table>
</div>
<div class="tx1"><b>${escapeHTML(notes.labelPrefix || 'Please Note:')}</b> ${escapeHTML(notes.lead || '')}</div>
<ul>${bullets}</ul>
<div class="tx2">
<div class="t1">${escapeHTML(notes.contact || '')}</div>
<button type="button" id="search_again_btn">${escapeHTML(notes.searchAgainLabel || 'Search Again')}</button>
</div>
</section>`;

  }
 
  form.addEventListener('submit', async (e) => {

    e.preventDefault();

    msg.style.display = 'none';

    clearFieldWarnings();

    result.innerHTML = '';

    form.classList.add('loading');
 
    // Ensure hidden is synced and exactly one field is provided

    syncHidden();

    const psinVal = onlyDigits(psinInp.value);

    const webVal  = onlyDigits(webInp.value);
 
    if (!psinVal && !webVal) {

      form.classList.remove('loading');

      document.querySelector('.psin').classList.add('warning');

      document.querySelector('.web').classList.add('warning');

      msg.textContent = 'Please enter either PSIN or Online order number.';

      msg.style.display = 'block';

      return;

    }

    if (psinVal && webVal) {

      form.classList.remove('loading');

      document.querySelector('.psin').classList.add('warning');

      document.querySelector('.web').classList.add('warning');

      msg.textContent = 'Please enter only one: PSIN or Online order number (not both).';

      msg.style.display = 'block';

      return;

    }
 
    try {

      const res = await fetch('https://tfg.tellmedia.com.au/order_lookup.php', {

        method: 'POST',

        body: new FormData(form), // includes hidden order_ref + surname

      });

      const data = await res.json().catch(() => null);

      if (!res.ok || !data || data.ok === false) {

        const errText = (data && (data.error || data.message)) || `Lookup failed (${res.status})`;

        throw new Error(errText);

      }
 
      document.querySelector('.lookup_order.center').style.display = 'none';

      result.innerHTML = renderSummary(data);
      insertEwayButtonIfNeeded(data);


      const again = document.getElementById('search_again_btn');

      if (again) {

        again.addEventListener('click', () => {

          window.scrollTo({ top: 0, behavior: 'smooth' });

          form.reset();

          refHidden.value = '';

          clearFieldWarnings();

          result.innerHTML = '';

          document.querySelector('.lookup_order.center').style.display = 'block';

        });

      }

      result.scrollIntoView({ behavior: 'smooth' });

    } catch (err) {

      if (err.message === 'Surname does not match our records for this order.') {

        document.querySelector('.surn').classList.add('warning');

      }

      msg.textContent = err.message || 'Something went wrong.';

      msg.style.display = 'block';

    } finally {

      form.classList.remove('loading');

    }

  });

(function(){
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => Array.from(c.querySelectorAll(s));
 const state = { done: false, verifying: false, processing: false };


 
  function getHolder() {
    return document.getElementById('ewayPayNow') || $('.eway-button')?.closest('div');
  }
 
 function getInfo(holder) {
  const btn  = holder?.querySelector('.eway-button.processed');
  const tipA = holder?.querySelector('a.right-tip[data-tips]');
  const tips = tipA?.getAttribute('data-tips') || '';

  // Receipt (already working)
  const receipt = (tips.match(/Receipt Number:\s*([0-9]+)/i) || [])[1] || '';

  // 🔥 NEW: try to extract Transaction ID
 

const transactionId = receipt; // ✅ IMPORTANT: Receipt Number is TransactionID in your case


  const cfg = holder?.querySelector('script.eway-paynow-button');

  return {
    ready: !!(btn && tipA && receipt), // ❌ do NOT rely on "accepted"
    tips,
    receipt,
    transactionId,
    amountCents: cfg?.getAttribute('data-amount') || '',
    currency:    cfg?.getAttribute('data-currency') || 'AUD',
    description: cfg?.getAttribute('data-description') || '',
    email:       cfg?.getAttribute('data-email') || '',
    phone:       cfg?.getAttribute('data-phone') || '',
    ref:         document.getElementById('order_ref_hidden')?.value || '',
    tipA
  };
}

 
  function showInlineTip(holder, tips) {
    if (!holder || !tips) return;
    // de-dupe
    $$('.eway-tip-inline', holder).forEach(n => n.remove());
    const box = document.createElement('div');
    box.className = 'eway-tip-inline';
    const ok = /accepted/i.test(tips);
    box.innerHTML = `<div><span class="tit">Payment Status:</span> <span class="${ok?'ok':''}">${tips}</span></div>`;
    // place after the right-tip anchor if present
    const anchor = holder.querySelector('a.right-tip');
    (anchor?.parentNode || holder).insertBefore(box, anchor ? anchor.nextSibling : null);
  }
 
  function centsToAmount(cents) {
    return (cents && !isNaN(cents)) ? (Number(cents)/100).toFixed(2) : '';
  }
 
 function openReceiptModal(defaultPhone, onSubmit, onSkip){
  const modal = document.getElementById('receiptModal');
  const closeBtn = document.getElementById('receiptModalClose');
  const skipBtn  = document.getElementById('receiptModalSkip');
  const sendBtn  = document.getElementById('receiptModalSend');
  const msgEl    = document.getElementById('receiptModalMsg');
  const phoneEl  = document.getElementById('receiptPhone');

  function showMsg(t){
    msgEl.textContent = t;
    msgEl.style.display = 'block';
  }
  function clearMsg(){
    msgEl.textContent = '';
    msgEl.style.display = 'none';
  }
  function close(){
    modal.style.display = 'none';
    clearMsg();
    closeBtn.removeEventListener('click', close);
    skipBtn.removeEventListener('click', skip);
    sendBtn.removeEventListener('click', send);
    modal.querySelector('.rmodal__overlay').removeEventListener('click', close);
    document.removeEventListener('keydown', onEsc);
  }
  function onEsc(e){ if(e.key === 'Escape') close(); }

  function normalizePhone(p){
    return String(p || '').replace(/[^\d+]/g,'').trim();
  }

  function send(){
    clearMsg();
    const phone = normalizePhone(phoneEl.value || '');
    if (!phone){
      showMsg('Please enter your mobile number.');
      return;
    }
    onSubmit({ phone, close, showMsg });
  }

  function skip(){
    close();
    onSkip && onSkip();
  }

  phoneEl.value = defaultPhone || '';
  modal.style.display = 'block';
  closeBtn.addEventListener('click', close);
  modal.querySelector('.rmodal__overlay').addEventListener('click', close);
  skipBtn.addEventListener('click', skip);
  sendBtn.addEventListener('click', send);
  document.addEventListener('keydown', onEsc);
}


function notifyServer(payload) {
  if (state.done || state.processing) return;
state.processing = true; // lock immediately


  const esuiteUrl = 'https://tfg.tellmedia.com.au/esuite_payprocess.php';
  const smsUrl    = 'https://tfg.tellmedia.com.au/send_receipt_sms.php';

  const esuiteData = {
    status: 'accepted',
    psin: payload.ref,
    receipt: payload.receipt,
    tips: payload.tips,
    amount: centsToAmount(payload.amountCents),
    currency: payload.currency,
    ref: payload.ref,
    description: payload.description
    // DO NOT send email anymore
    // phone will be collected from popup
  };

  // Step 1: send to eSuite processing endpoint
  fetch(esuiteUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams(esuiteData),
    keepalive: true
  })
  .then(async (r) => {
    const j = await r.json().catch(() => null);

    // Even if your esuite file returns plain text sometimes, don't hard-fail
    if (!r.ok) throw new Error('eSuite processing failed');

    // Mark done once eSuite work succeeded
    state.done = true;

    // Prepare receipt data for SMS endpoint.
    // Prefer values returned by PHP (if present); otherwise fallback to known payload fields.
    const receiptData = {
      OriginalOrderNumber: (j && (j.OriginalOrderNumber || j.order || j.psin || j.ref)) || payload.ref || '',
      BalancePaid:         (j && (j.BalancePaid || j.paid)) || (centsToAmount(payload.amountCents) ? ('$' + centsToAmount(payload.amountCents)) : ''),
      PaymentDate:         (j && (j.PaymentDate || j.date)) || new Date().toISOString().slice(0,10),
      ThisTransactionNo:   (j && (j.ThisTransactionNo || j.txn || j.receipt)) || payload.receipt || '',
      BalanceRemaining:    (j && (j.BalanceRemaining || j.remaining)) || ''
    };

    // Step 2: collect phone and send SMS
    const defaultPhone = (payload.phone || '').trim();

    openReceiptModal(defaultPhone, ({ phone, close, showMsg }) => {
      const smsData = { phone, ...receiptData };

      // Try beacon first (non-blocking)
      // Try beacon first (non-blocking)

try {

  const bodyStr = new URLSearchParams(smsData).toString();

  const body = new Blob([bodyStr], { type: 'application/x-www-form-urlencoded;charset=UTF-8' });
 
  if (navigator.sendBeacon && navigator.sendBeacon(smsUrl, body)) {

    showMsg('✅ Receipt sent successfully by SMS.');
    //alert('Receipt sent successfully by SMS.');

    setTimeout(() => close(), 3000);

    return;

  }

} catch (_) {}

 

      // Fallback fetch + show error if Twilio fails
     fetch(smsUrl, {
  method: 'POST',
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  body: new URLSearchParams(smsData),
  keepalive: true
})
.then(async (rr) => {
  const jj = await rr.json().catch(() => null);
 
  // 1) If API failed, show the real error
  if (!rr.ok || !jj || jj.ok !== true) {
    const errMsg = (jj && (jj.error || jj.detail)) || `SMS failed (HTTP ${rr.status})`;
    throw new Error(errMsg);
  }
 
  // 2) Success path: show msg, then close AFTER a delay
  showMsg('✅ Receipt sent successfully by SMS.');

  setTimeout(() => {
    close(); // close modal/dialog after user sees message
  }, 3000);
})
.catch((e) => {
  showMsg(e.message || 'SMS failed. Please try again.');
});

    }, () => {
      // user clicked Skip — do nothing
    });

    return j;
  })
  .catch((e) => {
    // eSuite failed — allow retry
    state.processing  = false;
    state.done = false;
    console.error('eSuite failed', e);
    // optional: console
    // console.error(e);
  });
}
async function verifyEwayTransaction(transactionId) {
  const url = 'https://tfg.tellmedia.com.au/eway_query.php';

  // Retry because eWAY may take a second to finalise
  const delays = [0, 800, 2000, 3500];

  for (const delay of delays) {
    if (delay) await new Promise(r => setTimeout(r, delay));

    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ transactionId }),
      keepalive: true
    });

    const json = await res.json().catch(() => null);

    if (json && json.ok === true) {
      return json; // definitive result
    }
  }

  return null;
}

 
 function tryProcess(observer) {
  try {
    if (state.done || state.verifying) return;

    const holder = getHolder();
    if (!holder) return;

    const info = getInfo(holder);
    if (!info.ready) return;

    state.verifying = true;      // ✅ verification lock
    observer && observer.disconnect();

    console.log('eWAY data-tips:', info.tips);
    showInlineTip(holder, 'Verifying payment with eWAY…');

    (async () => {
      const tx = info.transactionId || info.receipt;
      if (!tx) {
        state.verifying = false;
        showInlineTip(holder, '⚠️ Could not read transaction id. Please contact support.');
        return;
      }

      const verified = await verifyEwayTransaction(tx);

      if (!verified) {
        state.verifying = false;
        showInlineTip(holder, '⚠️ Payment not successful or not verified. Please try again or contact us at enquiry@thefg.com.au');
        return;
      }

      if (verified.transactionStatus === true) {
        showInlineTip(holder, '✅ Payment approved.');
        notifyServer({ ...info, transactionId: tx }); // ✅ this will run now
      } else {
        state.verifying = false; // allow retry
        const reason = verified.responseMessage || verified.errors || 'Declined';
        showInlineTip(holder, '❌ Payment failed: ' + reason);
      }
    })();

  } catch (e) {
    state.verifying = false;
    console.error('tryProcess error', e);
  }
}


 
  // Observe DOM for eWAY’s appended UI, but disconnect once handled
  const obs = new MutationObserver(() => tryProcess(obs));
  obs.observe(document.documentElement, { childList: true, subtree: true });
 
  // Also run a few timed checks (in case observer misses changes)
  setTimeout(() => tryProcess(obs), 300);
  setTimeout(() => tryProcess(obs), 1000);
  setTimeout(() => tryProcess(obs), 2500);
  setTimeout(() => tryProcess(obs), 5000);
})();
